(function(){
  function gal(g){
    var t=g.querySelector('.bf-gal__track');if(!t||t.__g)return;t.__g=1;
    var s=[].slice.call(t.children),n=g.querySelector('.bf-gal__n'),th=[].slice.call(g.querySelectorAll('.bf-gal__th button'));
    function cur(){return Math.round(t.scrollLeft/(t.clientWidth||1));}
    function go(i){i=Math.max(0,Math.min(s.length-1,i));t.scrollTo({left:i*t.clientWidth,behavior:'smooth'});}
    function upd(){var i=cur();if(n)n.textContent=(i+1)+' / '+s.length;th.forEach(function(b,k){b.classList.toggle('is-on',k===i);});
      s.forEach(function(x,k){var v=x.querySelector('video');if(v){k===i?v.play().catch(function(){}):v.pause();}});}
    var to;t.addEventListener('scroll',function(){clearTimeout(to);to=setTimeout(upd,60);});
    th.forEach(function(b,k){b.addEventListener('click',function(){go(k);});});
    var p=g.querySelector('.bf-gal__a--p'),nx=g.querySelector('.bf-gal__a--n');
    p&&p.addEventListener('click',function(){go(cur()-1);});nx&&nx.addEventListener('click',function(){go(cur()+1);});
    g.__go=function(mid){var k=s.findIndex(function(x){return x.dataset.mid==mid;});if(k>-1)go(k);};
    upd();
  }
  function money(c,f){return (f||'{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){var v=(c/100).toFixed(2);return k.indexOf('comma')>-1?v.replace('.',','):v;});}
  function pdp(r){
    if(r.__p)return;r.__p=1;
    var g=r.querySelector('.bf-gal');g&&gal(g);
    var j=r.querySelector('[data-bf-variants]'),f=r.querySelector('form[data-bf-pdp]');
    var vs=j?JSON.parse(j.textContent):[],fmt=r.dataset.money;
    var btn=f&&f.querySelector('button[type=submit]'),sb=document.querySelector('.bf-sticky button');
    function sel(){var o=[];r.querySelectorAll('.bf-opt').forEach(function(x){var c=x.querySelector('input:checked');o.push(c?c.value:null);});return o;}
    r.addEventListener('change',function(e){
      if(!e.target.closest('.bf-opt'))return;
      var o=sel(),v=vs.find(function(x){return x.options.every(function(y,i){return y===o[i];});});
      r.querySelectorAll('.bf-opt').forEach(function(x,i){var l=x.querySelector('.bf-opt__l span');if(l)l.textContent=o[i]||'';});
      if(!v)return;
      f.querySelector('[name=id]').value=v.id;
      document.querySelectorAll('[data-bf-price]').forEach(function(p){p.innerHTML=money(v.price,fmt)+(v.compare_at_price>v.price?'<s>'+money(v.compare_at_price,fmt)+'</s>':'');});
      [btn,sb].forEach(function(b){if(!b)return;b.disabled=!v.available;b.textContent=v.available?b.dataset.on:b.dataset.off;});
      if(v.featured_media&&g&&g.__go)g.__go(v.featured_media.id);
      try{history.replaceState(null,'','?variant='+v.id);}catch(x){}
    });
    var st=document.querySelector('.bf-sticky');
    if(st&&btn&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){st.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0);});}).observe(btn);
      sb&&sb.addEventListener('click',function(){f.requestSubmit?f.requestSubmit():f.submit();});
    }
  }
  function init(){document.querySelectorAll('[data-bf-pdp-root]').forEach(pdp);}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
